import Component from '../../classes/Component';
import {$events} from "../../helpers/events";
import variables from "../../variables";
import gsap from 'gsap'
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {$dom} from "../../helpers/dom";

gsap.registerPlugin(ScrollTrigger);

const {customEventNames} = variables;
const animateAttr = 'data-animate';
const selector = `[${animateAttr}]`;
const numberOutputAttr = 'data-number';
const animationStartAttr = 'data-start-point';

const fromDefaults = {
    autoAlpha: 0,
    xPercent: -5
};
const toDefaults = {
    autoAlpha: 1,
    xPercent: 0
};

gsap.defaults({ease: 'ease.in', duration: variables.gsapDefaultDuration});

export default function () {

    return new Component({
        name: 'animation',
        requiredTargets: selector,
        onInit() {
            const getAnimatedElements = (name, outIsArray = false, parent = document) => {
                return $dom[outIsArray ? 'getAll' : 'get'](`[${animateAttr}="${name}"]`, parent)
            };

            const getCountElements = name => {
                let holder = null, output = null, count = 0;

                const numberHolderEl = getAnimatedElements(name);

                if (numberHolderEl) {
                    holder = numberHolderEl;

                    if ($dom.exist(`[${numberOutputAttr}]`, numberHolderEl)) {
                        output = $dom.get(`[${numberOutputAttr}]`, numberHolderEl);
                        count = +output.getAttribute(numberOutputAttr)
                    }
                }

                return {holder, output, count};
            };

            const separate_thousands = x => x
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, " ");

            this.handleIntroImageLoaded = () => {
                const introTitle = getAnimatedElements('intro-title');
                const introSubtitle = getAnimatedElements('intro-subtitle');
                const introFooterElements = getAnimatedElements('intro-footer', true);

                const tl = gsap.timeline({delay: .5})
                    .fromTo(getAnimatedElements('header'), {
                        autoAlpha: 0,
                        yPercent: -5
                    }, {
                        autoAlpha: 1,
                        yPercent: 0
                    })
                    .fromTo(introTitle, fromDefaults, toDefaults)
                    .fromTo(introSubtitle, fromDefaults, toDefaults)
                ;

                ['intro-number-members', 'intro-number-clubs', 'intro-number-hours']
                    .forEach(name => {
                        const countElements = getCountElements(name);
                        const {holder, output} = countElements;

                        tl
                            .fromTo(holder, fromDefaults, toDefaults, 'count')
                            .from(countElements, {
                                duration: 3,
                                count: 0,
                                roundProps: 'count',
                                onUpdate: function() {
                                    output.innerText = separate_thousands(countElements.count);
                                }
                            }, 'count')

                    });

                tl.fromTo(introFooterElements, fromDefaults, {
                    ...toDefaults,
                    stagger: .25
                }, 'count+=.5');

            };

            $dom.each(getAnimatedElements('section', true), (section, index) => {
                gsap.set(section, {opacity: 1, overflow: 'hidden'});
                const sectionElements = getAnimatedElements('section-element', true, section);
                const start = section.getAttribute(animationStartAttr) || 'top';

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: `${start} center`,
                        markers: false,
                    }
                });

                const axis = section.getAttribute('data-axis') || (index % 2 === 0 ? 'x' : 'y');
                let direction = section.getAttribute('data-direction');

                direction
                    ? direction = Number(direction)
                    : direction = 1;

                $dom.each(sectionElements, (element, i) => {
                    tl.fromTo(element, {
                        autoAlpha: 0,
                        [axis]: gsap.utils.random(0, 100) * direction
                    }, {
                        autoAlpha: 1,
                        [axis]: 0
                    })
                })

            });

            $events.delegate
                .on(customEventNames.introImageLoaded, window, this.handleIntroImageLoaded)
        },
        onDestroy() {
            $events.delegate
                .off(customEventNames.introImageLoaded, window, this.handleIntroImageLoaded)
        }
    })
}
